const overlay  = document.getElementById('search-overlay');
const trigger  = document.getElementById('search-trigger');
const closeBtn = document.getElementById('search-overlay-close');
const input    = overlay ? overlay.querySelector('.search-overlay__input') : null;

if (overlay && trigger) {
	const open = () => {
		overlay.classList.add('is-open');
		overlay.setAttribute('aria-hidden', 'false');
		overlay.inert = false;
		document.body.style.overflow = 'hidden';
		if (input) input.focus();
	};

	const close = () => {
		overlay.classList.remove('is-open');
		overlay.setAttribute('aria-hidden', 'true');
		overlay.inert = true; // закрите вікно — поза фокусом і деревом доступності
		document.body.style.overflow = '';
	};

	trigger.addEventListener('click', (e) => {
		e.preventDefault();
		open();
	});

	if (closeBtn) closeBtn.addEventListener('click', close);

	overlay.addEventListener('click', (e) => {
		if (e.target === overlay) close();
	});

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
	});
}
